import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import rewardArt from '../../assets/images/reward_art.png';
import rewardBarBg from '../../assets/images/reward_bar_bg.png';
import rewardRings from '../../assets/images/reward_rings.svg';

const StyledContainer = styled.div`
	position: relative;
	width: 400px;
	height: 220px;
	background: rgba(255, 68, 0, 0.05);
	box-shadow: inset 0 0 0 1px rgba(255, 128, 0, 0.5);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledLights = styled.div`
	position: absolute;
	inset: 0;
	background: radial-gradient(
			circle 230px at 200px 0px,
			rgba(255, 166, 0, 0.62) 0%,
			rgba(255, 166, 0, 0) 100%
		),
		radial-gradient(
			circle 240px at 0px 0px,
			rgba(255, 60, 0, 0.14) 0%,
			rgba(255, 60, 0, 0) 100%
		),
		radial-gradient(
			circle 240px at 400px 0px,
			rgba(255, 60, 0, 0.14) 0%,
			rgba(255, 60, 0, 0) 100%
		),
		radial-gradient(
			circle 170px at 200px 110px,
			rgba(0, 0, 0, 0.42) 0%,
			rgba(0, 0, 0, 0) 100%
		),
		radial-gradient(
			circle 200px at 200px 190px,
			rgba(0, 0, 0, 0.22) 0%,
			rgba(0, 0, 0, 0) 100%
		);
`;

const StyledRings = styled.div`
	position: absolute;
	top: -200px;
	left: -100px;
	width: 600px;
	height: 600px;
	background-image: url(${rewardRings});
	background-size: contain;
	background-repeat: no-repeat;
`;

const StyledArt = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 400px;
	height: 200px;
	overflow: hidden;
	mask-image: linear-gradient(180deg, #000000 85%, rgba(0, 0, 0, 0) 100%);
	-webkit-mask-image: linear-gradient(
		180deg,
		#000000 85%,
		rgba(0, 0, 0, 0) 100%
	);

	&::before {
		content: '';
		position: absolute;
		top: 22px;
		left: 54px;
		width: 296px;
		height: 295px;
		background-image: url(${rewardArt});
		background-size: contain;
		background-repeat: no-repeat;
	}
`;

const StyledDiamond = styled.div<{ $left: number }>`
	position: absolute;
	top: 20px;
	left: ${({ $left }) => $left}px;
	width: 10px;
	height: 10px;
	background: rgba(255, 174, 0, 0.5);
	border: 1px solid #ffae00;
	transform: rotate(45deg);
`;

const StyledShadow = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	top: 118px;
	height: 100px;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	opacity: 0.5;
`;

const StyledBar = styled.div`
	position: absolute;
	top: 170px;
	left: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 380px;
	height: 40px;
	padding: 0 15px;
	background-image: url(${rewardBarBg});
	background-size: cover;
	border-radius: 5px;

	& > ${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledAmounts = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
`;

const StyledAmount = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledDivider = styled.div`
	width: 2px;
	height: 38px;
	background: linear-gradient(
		90deg,
		rgba(255, 255, 255, 0.1) 0%,
		rgba(255, 255, 255, 0.1) 50%,
		rgba(0, 0, 0, 0.1) 50%,
		rgba(0, 0, 0, 0.1) 100%
	);
`;

export {
	StyledAmount,
	StyledAmounts,
	StyledArt,
	StyledBar,
	StyledContainer,
	StyledDiamond,
	StyledDivider,
	StyledLights,
	StyledRings,
	StyledShadow,
};
